import { useSurveyScheduler } from "../../../hooks/useSurveyScheduler";
import {
  localStorageProvider,
  engagementTrackerProvider,
} from "../../../AppController";

const SurveyScheduler = () => {
  useSurveyScheduler({
    localStorageProvider,
    engagementTrackerProvider,
  });
  return null; // This component doesn't render anything, just runs the hook
};

export default SurveyScheduler;
